module.exports = __webpack_public_path__ + "img/naomi.bb23c289.png";